import { IRelatedProductsResponse } from "src/api/client/related-products.api.types";
import { createApiWikifolioGroupUrl } from "src/constants/urls";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";

export function useRelatedProductsQuery(wikifolioId: string) {
    return useQuery<IRelatedProductsResponse>({
        url: createApiWikifolioGroupUrl(wikifolioId),
        queryParams: new URLSearchParams({ offset: "0", limit: "100" }),
        retry: 0,
    });
}
